import React from "react";
import { Grid } from "@mui/material";
import Button from "../common/Button";
import { CONTRACT_TABS } from "./formDefaults";

const ContractTypeTabs = ({
  value,
  onChange,
  translate,
  themecolors,
  widths = { maintenance: "60%", leasing: "50%", cashCustomer: "75%" },
}) => (
  <Grid item xs={5} sm={5} style={{ display: "flex" }}>
    {CONTRACT_TABS.map((tab) => {
      const active = value === tab.id;
      return (
        <Button
          key={tab.id}
          variant="contained"
          color="secondary"
          onClick={() => onChange(tab.id)}
          style={{
            width: widths[tab.id] || "50%",
            borderTopRightRadius: "15px",
            borderTopLeftRadius: "15px",
            marginLeft: "5px",
            backgroundColor: active ? themecolors?.themeLightColor : "#ffff",
            color: active ? "#ffff" : themecolors?.themeLightColor,
          }}
        >
          {translate(tab.labelKey)}
        </Button>
      );
    })}
  </Grid>
);

export default ContractTypeTabs;
